import { SET_LOADING, SET_PROGRESS } from '../types/loader';

const initialLoaderState = {
  loading: false,
  progress: 0,
};

const loaderReducer = (state = initialLoaderState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_PROGRESS:
      return {
        ...state,
        progress: action.payload,
      };
    default:
      return state;
  }
};

export default loaderReducer;